import { useTranslation } from "react-i18next";
import { FunctionComponent } from "react";

interface Props {
    id: String,
    param?: object,
}

export const FormattedMsgWithDOM: FunctionComponent<Props> = (props): JSX.Element => {
    const { t } = useTranslation();
    return (<div dangerouslySetInnerHTML={{ __html: t(`${props.id}`, props.param) }} />);
}

export const FormattedMsg: FunctionComponent<Props> = (props): JSX.Element => {
    const { t } = useTranslation();
    return (t(`${props.id}`, props.param));
}